import { endpoint } from './endpoint.js';
import { GeocodingSearchQuerySchema, GeocodingSearchResponseSchema } from '../schemas/geocoding.js';

export const geocoding = {
  search: endpoint(
    'GET',
    '/geocoding/search',
    GeocodingSearchQuerySchema,
    GeocodingSearchResponseSchema,
  ),
};
